import { UserRequestSteps } from "./Requests.tsx";
import {  reqManualCreate, reqSecurityCreate, requestUserCreateStep, reqUserCreate } from "./Create.tsx";
import { requestDetailsEditStep, requestRolesEditSteps } from "./Edit.tsx";

/**
 * Dynamically return the appropriate Joyride steps based on the path and query params
 * @param {string} path - current URL pathname
 * @param {URLSearchParams} query - query object (new URLSearchParams(location.search))
 * @returns {Array} steps - Joyride steps
 */
export const getUserRequestJoyrideSteps = (path, query, activeTab) => {
  if (path === "/requests") {
    return UserRequestSteps;
  }

  if (path === "/requests/create") {

    // Create mode
    if(activeTab==='user'){
        return [...requestUserCreateStep,...reqUserCreate]
    }
      if(activeTab==='group'){
        return [...requestUserCreateStep,...reqSecurityCreate]
    }
       if(activeTab==='manual'){
        return [...requestUserCreateStep,...reqManualCreate]
    }
  }
  if (path === "/requests/edit") {
    if (activeTab === "details") return requestDetailsEditStep;
    if (activeTab === "roles") return requestRolesEditSteps;
  }
};
